
import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

import dlLogo from '../assect/images/svg/dl_headerlogo.svg'

export default function Navbar({navClass,logolight,menuClass}){
    const [scroll, setScroll] = useState(false);
    const [isMenu, setisMenu] = useState(false);
    const [modal, setModal] = useState(false)

    useEffect(() => {
        activateMenu()
        window.addEventListener("scroll", () => {
          setScroll(window.scrollY > 50);
        });
        const closeDropdown =()=>{
            setModal(false)
        }
        document.addEventListener("mousedown", closeDropdown);
        window.scrollTo(0, 0);
      }, []);

      var mybutton = document.getElementById("back-to-top");
        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if(mybutton!=null){
                if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                    mybutton.style.display = "block";
                } else {
                    mybutton.style.display = "none";
                }
            }
        }
        
        // Toggle menu
        const toggleMenu = () => {
            setisMenu(!isMenu);
            if (document.getElementById("navigation")) {
                const anchorArray = Array.from(document.getElementById("navigation").getElementsByTagName("a"));
                anchorArray.forEach(element => {
                    element.addEventListener('click', (elem) => {
                        const target = elem.target.getAttribute("href")
                        if (target !== "") {
                            if (elem.target.nextElementSibling) {
                                var submenu = elem.target.nextElementSibling.nextElementSibling;
                                submenu.classList.toggle('open');
                            }
                        }
                    })
                });
            }
        };
        function getClosest(elem, selector) {

            // Element.matches() polyfill
            if (!Element.prototype.matches) {
                Element.prototype.matches =
                    Element.prototype.matchesSelector ||
                    Element.prototype.mozMatchesSelector ||
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.oMatchesSelector ||
                    Element.prototype.webkitMatchesSelector ||
                    function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                            i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) { }
                        return i > -1;
                    };
            }

            // Get the closest matching element
            for (; elem && elem !== document; elem = elem.parentNode) {
                if (elem.matches(selector)) return elem;
            }
            return null;

        };

        function activateMenu() {
            var menuItems = document.getElementsByClassName("sub-menu-item");
            if (menuItems) {

                var matchingMenuItem = null;
                for (var idx = 0; idx < menuItems.length; idx++) {
                    if (menuItems[idx].href === window.location.href) {
                        matchingMenuItem = menuItems[idx];
                    }
                }

                if (matchingMenuItem) {
                    matchingMenuItem.classList.add('active');
                
                
                    var immediateParent = getClosest(matchingMenuItem, 'li');
            
                    if (immediateParent) {
                        immediateParent.classList.add('active');
                    }
                    
                    var parent = getClosest(immediateParent, '.child-menu-item');
                    if(parent){
                        parent.classList.add('active');
                    }

                    var parent = getClosest(parent || immediateParent , '.parent-menu-item');
                
                    if (parent) {
                        parent.classList.add('active');

                        var parentMenuitem = parent.querySelector('.menu-item');
                        if (parentMenuitem) {
                            parentMenuitem.classList.add('active');
                        }

                        var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
                        if (parentOfParent) {
                            parentOfParent.classList.add('active');
                        }
                    } else {
                        var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
                        if (parentOfParent) {
                            parentOfParent.classList.add('active');
                        }
                    }
                }
            }
        }
    return(
        <>
         <header id="topnav" className={`${scroll ? "nav-sticky" :""} ${navClass}`}>
            <div className="container" style={{padding: 0, margin: 0}}>
                <Link className="bg-white logo-svg" to="/">
                    <img src={dlLogo} width="277" className="img-fluid" alt=""/>
                </Link>
                
                <div id="navigation" style={{ display: isMenu ? 'block' : 'none' }}>
                    <ul className={menuClass}>
                        <li><Link reloadDocument to={{ pathname: "/PropertyListing", search:"propertyType=F", key: uuidv4() }}>Furnished</Link></li>
                        <li><Link reloadDocument to={{ pathname: "/PropertyListing", search:"propertyType=U", key: uuidv4() }}>UnFurnished</Link></li>
                        <li><Link reloadDocument to={{ pathname: "/PropertyListing", search:"propertyType=SF", key: uuidv4() }}>Semi-Furnished</Link></li>
                        <li className="has-submenu parent-parent-menu-item"><Link to="#">About</Link><span className="menu-arrow"></span>
                            <ul className="submenu">
                                <li><Link to="/aboutus" className="sub-menu-item">About Us</Link></li>
                                <li><Link to="/generalinformation" className="sub-menu-item">General Information</Link></li>
                                <li><Link to="/leasingprocess" className="sub-menu-item">Leasing Process</Link></li>
                                <li><Link to="/faqs" className="sub-menu-item">FAQ</Link></li>
                            </ul>
                        </li>
                        <li><Link to="/contactus">Contact Us</Link></li>
                        <li className="margin-2"><Link to="/discovertroy">Discover Troy</Link></li>
                        <li className="light-green-background"><Link to="/contactus">Inquire</Link></li>
                    </ul>
                </div>
            </div>
        </header>
        </>
    )
}
